export default "__VITE_ASSET__DLd2xL6q__"